module.exports = __webpack_public_path__ + "img/graphs_cycle_illustration.e483df74.jpg";